import React from 'react';
import styled from 'styled-components';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';

const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacer-S);
`;

const SectionTitle = styled.h3`
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: var(--text-body);
`;

const BarRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacer-XXS);
`;

const BarLabel = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.88rem;
    color: var(--text-body);
`;

const BarTrack = styled.div`
    background: var(--appLigthGrey);
    border-radius: 999px;
    height: 8px;
    overflow: hidden;
`;

interface CampaignFailureBreakdownProps {
    breakdown: Record<string, number>;
}

export const CampaignFailureBreakdown: React.FC<CampaignFailureBreakdownProps> = ({ breakdown }) => {
    const t = useTranslations();
    const entries = Object.entries(breakdown).sort(([, a], [, b]) => b - a);
    const maxCount = entries.length > 0 ? entries[0][1] : 1;

    if (!entries.length) {
        return (
            <Section>
                <SectionTitle>{t(TK.campaignAnalyticsFailureBreakdown)}</SectionTitle>
                <div style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>{t(TK.campaignAnalyticsNoFailures)}</div>
            </Section>
        );
    }

    return (
        <Section>
            <SectionTitle>{t(TK.campaignAnalyticsFailureBreakdown)}</SectionTitle>
            {entries.map(([reason, count]) => (
                <BarRow key={reason}>
                    <BarLabel>
                        <span>{reason}</span>
                        <strong>{count}</strong>
                    </BarLabel>
                    <BarTrack>
                        <div style={{
                            background: 'var(--danger-color)',
                            width: `${Math.round((count / maxCount) * 100)}%`,
                            height: '100%',
                            borderRadius: '999px',
                        }} />
                    </BarTrack>
                </BarRow>
            ))}
        </Section>
    );
};
